import httpService from "core/services/httpService";

import API_URL from "core/constants/api/apiUrl";

const brandService = {
    getGeneralInfo(data, signal){
        return httpService.get({
            url: API_URL.GET_BRAND_GENRAL_INFO,
            signal,
            queryData: data
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    saveGeneralInfo(data, signal){
        return httpService.post({
            url: API_URL.SAVE_BRAND_GENRAL_INFO,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    getDomains(data, signal){
        return httpService.get({
            url: API_URL.GET_BRAND_DOMAINS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return value
        })
    },

    addDomain(data, signal){
        return httpService.post({
            url: API_URL.ADD_BRAND_DOMAIN,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    saveDomain(data, signal){
        return httpService.post({
            url: API_URL.SAVE_BRAND_DOMAIN,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    setDomainAsDefault(data, signal){
        return httpService.post({
            url: API_URL.SAVE_BRAND_DOMAIN_AS_DOMAIN,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    deleteDomain(data, signal){
        return httpService.delete({
            url: API_URL.DELETE_BRAND_DOMAIN,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    getLandings(data, signal){
        return httpService.get({
            url: API_URL.GET_BRAND_LANDINGS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return value
        })
    },

    addLanding(data, signal){
        return httpService.post({
            url: API_URL.ADD_BRAND_LANDING,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    saveLanding(data, signal){
        return httpService.post({
            url: API_URL.SAVE_BRAND_LANDING,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    deleteLanding(data, signal){
        return httpService.delete({
            url: API_URL.DELETE_BRAND_LANDING,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    getMobileUrls(data, signal){
        return httpService.get({
            url: API_URL.GET_BRAND_MOBILE_URLS,
            signal,
            queryData: { ...data }
        }).then(({ data: { value } }) => {
            return value
        })
    },

    addMobileUrl(data, signal){
        return httpService.post({
            url: API_URL.ADD_BRAND_MOBILE_URL,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    saveMobileUrl(data, signal){
        return httpService.post({
            url: API_URL.SAVE_BRAND_MOBILE_URL,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },

    deleteMobileUrl(data, signal){
        return httpService.delete({
            url: API_URL.DELETE_BRAND_MOBILE_URL,
            signal,
            requestBody: data
        }).then(({ data: { value, message } }) => {
            return { value, message };
        })
    },
}

export default brandService;